const sms = {
  content: "เนื้อหา SMS",
  sendTime: "ส่งเวลา",
  result: "ผลลัพธ์",
  searchLabelWidth: '140px'
} 
export default sms